// The payment state of a pending booking, the same on the student's and the instructor's side.
// "Payment sent" is a marker the student sets with a screenshot; the booking stays pending until
// the instructor confirms (glossary: never "paid", which is the instructor's confirmation).
import React from 'react';
import { Badge } from './index';

const PENDING = 'pending';

export function isPaymentSent(booking) {
  return Boolean(booking && booking.status === PENDING && booking.paymentSentAt);
}

export function PaymentSentBadge({ booking, awaitingLabel = 'Awaiting payment' }) {
  if (!booking || booking.status !== PENDING) return null;
  return isPaymentSent(booking)
    ? <Badge variant="blue">Payment sent</Badge>
    : <Badge variant="gold">{awaitingLabel}</Badge>;
}

// A confirmed booking its booking payment confirmed (JTP-23): the instructor has no screenshot to
// look for, because JTPay reported the payment Paid. paidThroughRopida comes from the API.
export function PaidThroughRopidaBadge({ booking }) {
  if (!booking?.paidThroughRopida) return null;
  return <Badge variant="sage">Paid through Ropida</Badge>;
}
